import axios from "./axiosInstance";
import { Globals } from "../global/Globals";

const fetchCarousals = async () => {
    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.CAROUSAL;
     const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
        "Accept-Language": localStorage.getItem("lang") || "en", // Use the language from localStorage or default to 'en'
      },
    };
    const apiResponse = await axios.get(Globals.ENDPOINT.CAROUSAL,config);
    return apiResponse;
}
export default fetchCarousals;